import { schema } from '../schema';

export function validateAskSchema(ask: string | null | undefined): boolean {
	const askSchema = schema.shape.ask;
	const result = askSchema.safeParse(ask);

	return !!result.success;
}
